/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonTagViewModel } from "../types/PersonTagViewModel.ts";

export const personTagViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  tagId: z.optional(z.number().int()),
}) as unknown as ToZod<PersonTagViewModel>;
